import * as React from 'react';
import { Layout } from '../../Layout';
import * as styles from './SpecialFskIntroduction.css';

interface IIntroductionProps {
  backgroundImage: React.ReactNode;
  title: React.ReactNode;
  logo: React.ReactNode;
  contacts: React.ReactNode;
  facts: React.ReactNode;
  disclaimer?: React.ReactNode;
}

export function SpecialFskIntroduction({
  backgroundImage,
  logo,
  title,
  facts,
  contacts,
  disclaimer,
}: IIntroductionProps) {
  return (
    <section id="main" className={styles['introduction']}>
      <div className={styles['introduction__image']}>{backgroundImage}</div>

      <div className={styles['content']}>
        <Layout>
          <div className={styles['content__wrapper']}>
            <div className={styles['content__logo']}>{logo}</div>
            <div className={styles['content__title']}>{title}</div>

            {facts}

            <div className={styles['content__contacts']}>{contacts}</div>
            {disclaimer && (
              <div data-testid={'FskIntroDisclaimer'} className={styles['content__disclaimer']}>
                {disclaimer}
              </div>
            )}
          </div>
        </Layout>
      </div>
    </section>
  );
}
